import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["arrowFill", "arrowDirection", "children", "onClick", "className", "labelColor", "labelWeight", "href", "isBlankUrlTarget"];
import React from 'react';
import classNames from 'classnames/bind';
import { MenuUrlTarget } from '@carnica/smart-kit';
import PropTypes from 'prop-types';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../utils";
import { IconArrow } from "./IconArrow";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _ButtonArrow = function _ButtonArrow(props) {
  var _props$arrowFill = props.arrowFill,
    arrowFill = _props$arrowFill === void 0 ? 'white' : _props$arrowFill,
    _props$arrowDirection = props.arrowDirection,
    arrowDirection = _props$arrowDirection === void 0 ? 'right' : _props$arrowDirection,
    children = props.children,
    onClick = props.onClick,
    className = props.className,
    _props$labelColor = props.labelColor,
    labelColor = _props$labelColor === void 0 ? 'primary' : _props$labelColor,
    _props$labelWeight = props.labelWeight,
    labelWeight = _props$labelWeight === void 0 ? 'normal' : _props$labelWeight,
    href = props.href,
    isBlankUrlTarget = props.isBlankUrlTarget,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = href ? 'a' : 'div';
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cx('button', className),
    href: href,
    onClick: onClick,
    target: MenuUrlTarget.get(isBlankUrlTarget)
  }, otherProps, {
    "data-t-id": "components-ButtonArrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('button-wrap', "text-color--".concat(labelColor), "text-weight--".concat(labelWeight)),
    "data-t-id": "components-ButtonArrow"
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('button-content')
  }, children), /*#__PURE__*/React.createElement("span", {
    className: cx('icon', "icon-fill--".concat(arrowFill))
  }, /*#__PURE__*/React.createElement(IconArrow, {
    color: labelColor,
    direction: arrowDirection
  }))));
};
export var ButtonArrow = compose(enhancedConnect({
  arrowFill: PropTypes.oneOf(['primary', 'secondary']),
  arrowDirection: PropTypes.oneOf(['bottom-left', 'bottom-right', 'down', 'left', 'right', 'top-left', 'top-right', 'up']),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  href: PropTypes.string,
  isBlankUrlTarget: PropTypes.bool,
  labelColor: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  labelWeight: PropTypes.oneOf(['bold', 'light', 'medium', 'normal'])
}), withAutoMetric.Element(function (props) {
  return {
    name: 'ButtonArrow',
    text: props.children
  };
}))(_ButtonArrow);